import axios from "axios";

export const MEAL_INCIDENTS_BASE = "/meal/incidencias";

export const MEAL_INCIDENT_ENDPOINTS = Object.freeze({
  projects: `${MEAL_INCIDENTS_BASE}/proyectos`,
  summary: `${MEAL_INCIDENTS_BASE}/resumen`,
  list: MEAL_INCIDENTS_BASE,
  detail: (incidentId) => `${MEAL_INCIDENTS_BASE}/${incidentId}`,
  events: (incidentId) => `${MEAL_INCIDENTS_BASE}/${incidentId}/eventos`,
  assign: (incidentId) => `${MEAL_INCIDENTS_BASE}/${incidentId}/asignar`,
  startReview: (incidentId) => `${MEAL_INCIDENTS_BASE}/${incidentId}/iniciar-revision`,
  revalidate: (incidentId) => `${MEAL_INCIDENTS_BASE}/${incidentId}/revalidar`,
  validate: (incidentId) => `${MEAL_INCIDENTS_BASE}/${incidentId}/validar`,
  discard: (incidentId) => `${MEAL_INCIDENTS_BASE}/${incidentId}/descartar`,
  analyze: `${MEAL_INCIDENTS_BASE}/analizar`,
  exportControl: `${MEAL_INCIDENTS_BASE}/exportar`,
  exportClosure: `${MEAL_INCIDENTS_BASE}/exportar-cierre`,
});

const CONTROL_EXPORT_PARAMS = Object.freeze([
  "projectId",
  "status",
  "priority",
  "type",
  "assignedTo",
  "conditionActive",
  "dateFrom",
  "dateTo",
]);
const CLOSURE_EXPORT_PARAMS = Object.freeze(["projectId", "dateFrom", "dateTo"]);

const pickRequestParams = (params = {}, allowedKeys = []) =>
  allowedKeys.reduce((result, key) => {
    const value = params[key];
    if (value !== "" && value !== null && value !== undefined) result[key] = value;
    return result;
  }, {});

const unwrapData = (response) => {
  const payload = response?.data;
  return payload?.data ?? payload ?? {};
};

export const getMealProjects = async () => {
  const response = await axios.get(MEAL_INCIDENT_ENDPOINTS.projects);
  const data = unwrapData(response);
  if (Array.isArray(data)) return data;
  return Array.isArray(data.projects) ? data.projects : [];
};

export const getMealSummary = async (projectId) => {
  const response = await axios.get(MEAL_INCIDENT_ENDPOINTS.summary, {
    params: { projectId },
  });
  return unwrapData(response);
};

export const getMealIncidents = async (params) => {
  const response = await axios.get(MEAL_INCIDENT_ENDPOINTS.list, { params });
  const payload = response?.data || {};
  const data = payload?.data ?? payload;
  const incidents = Array.isArray(data)
    ? data
    : data.items || data.incidents || data.rows || [];

  return {
    incidents: Array.isArray(incidents) ? incidents : [],
    pagination:
      payload.meta?.pagination || data.meta?.pagination || data.pagination || {},
  };
};

export const getMealIncident = async (incidentId) => {
  const response = await axios.get(MEAL_INCIDENT_ENDPOINTS.detail(incidentId));
  return unwrapData(response);
};

export const getMealIncidentEvents = async (incidentId) => {
  const response = await axios.get(MEAL_INCIDENT_ENDPOINTS.events(incidentId));
  const data = unwrapData(response);
  if (Array.isArray(data)) return data;
  return Array.isArray(data.events) ? data.events : data.history || [];
};

export const analyzeMealProject = async (projectId) => {
  const response = await axios.post(MEAL_INCIDENT_ENDPOINTS.analyze, {
    projectId,
  });
  return unwrapData(response);
};

export const exportMealIncidents = (params) =>
  axios.get(MEAL_INCIDENT_ENDPOINTS.exportControl, {
    params: pickRequestParams(params, CONTROL_EXPORT_PARAMS),
    responseType: "blob",
  });

export const exportMealClosure = (params) =>
  axios.get(MEAL_INCIDENT_ENDPOINTS.exportClosure, {
    params: pickRequestParams(params, CLOSURE_EXPORT_PARAMS),
    responseType: "blob",
  });

export const assignMealIncident = async (incidentId, assignedTo) => {
  const response = await axios.post(MEAL_INCIDENT_ENDPOINTS.assign(incidentId), {
    assignedTo,
  });
  return unwrapData(response);
};

export const startMealIncidentReview = async (incidentId) => {
  const response = await axios.post(MEAL_INCIDENT_ENDPOINTS.startReview(incidentId));
  return unwrapData(response);
};

export const revalidateMealIncident = async (incidentId) => {
  const response = await axios.post(MEAL_INCIDENT_ENDPOINTS.revalidate(incidentId));
  return unwrapData(response);
};

export const validateMealIncident = async (incidentId, values) => {
  const response = await axios.post(
    MEAL_INCIDENT_ENDPOINTS.validate(incidentId),
    values
  );
  return unwrapData(response);
};

export const discardMealIncident = async (incidentId, values = {}) => {
  const response = await axios.post(MEAL_INCIDENT_ENDPOINTS.discard(incidentId), {
    resolutionType: values.resolutionType || "SIN_INCIDENCIA",
    comment: values.comment,
  });
  return unwrapData(response);
};
